import { CHANNEL } from 'constants/ChatConstants';

export const FIELD_MAPPING = {
  email: CHANNEL.EMAIL,
  sms: CHANNEL.SMS,
};

/**
 * @param {Partial<import("./types").Campaign>} campaign
 * @returns {import("modules/global/typing/enums/steps.enum").ChannelEnum[]}
 */
export const getActivatedChannels = campaign =>
  Object.entries(FIELD_MAPPING).reduce((acc, [field, channel]) => {
    if (campaign?.[field]?.enabled) {
      acc.push(channel);
    }
    return acc;
  }, []);

/**
 * @param {Partial<import("./types").Campaign>} campaign
 * @returns {import("modules/global/typing/enums/steps.enum").ChannelEnum}
 */
export const determinatePriorityChannel = campaign => {
  const config = Object.entries(FIELD_MAPPING).find(([fieldName]) => campaign?.[fieldName]?.priority);
  return config?.pop();
};
